<template>
    <!-- 我的成就模块 -->
    <div class="box-top-achievement">
        <div class="box-top-achievement-item">
            <div class="group_5">
                <span class="font_2">{{achievementInfo[achievementDsec[0].key]}}</span>
                <span class="font_4">{{achievementDsec[0].unit}}</span>
            </div>
            <span class="font_3">{{achievementDsec[0].desc}}</span>
        </div>
        <div class="box-top-achievement-item">
            <div class="group_5">
                <span class="font_2">{{achievementInfo[achievementDsec[1].key]}}</span>
                <span class="font_4">{{achievementDsec[1].unit}}</span>
            </div>
            <span class="font_3">{{achievementDsec[1].desc}}</span>
        </div>
        <div class="box-top-achievement-item">
            <div class="group_5">
                <span class="font_2">{{achievementInfo[achievementDsec[2].key]}}</span>
                <span class="font_4">{{achievementDsec[2].unit}}</span>
            </div>
            <span class="font_3">{{achievementDsec[2].desc}}</span>
        </div>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import {COURSE_TYPE} from '@/utils/commonConst';

@Options({
    components: {
    },
    props: {
        pageData: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    computed: {

    },
    created() {
        const {courseTypeId, achievement, classPerformanceInfo} = this.pageData;
        const {name, desc} = COURSE_TYPE[courseTypeId || 1];
        this.achievementDsec = desc;
        // 中教，外教，小班课展示classPerformanceInfo;
        /**
         * 1-古诗课 29-复习课 13-阅读课 25-历史课 26-小古文课 30-表达课 12-拼音课 31-小班直播课
         * 做伪直播课程也就是之前的复习课，因此不会在进来h5的这个29-复习课了
         * 中教课=36；外教课=37；绘本精讲课—阅读=35；绘本精讲课—英语=38
         */
        const useClassPerformanceInfo = courseTypeId === 31 || courseTypeId === 36 || courseTypeId === 37;
        this.achievementInfo = useClassPerformanceInfo ? classPerformanceInfo : achievement;
    }
})
export default class Achievement extends Vue {
    achievementInfo = {};
    achievementDsec = null;
}
</script>

<style lang="scss" scoped>
// 成就
.box-top-achievement {
    display: flex;
    justify-content: space-between;
    width: 97%;
    margin-bottom: .85rem;

    &-item {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;

        .group_5 {

            .font_2 {
                font-size: .85rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #FF781E;
                line-height: 1.07rem;
                letter-spacing: .007rem;
                margin-right: 0.05rem;
            }

            .font_4 {
                font-size: .32rem;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #0B0B0B;
                line-height: .43rem;
            }
        }

        .font_3 {
            font-size: .32rem;
            font-family: PingFangSC, PingFang SC;
            color: #333333;
            margin-top: .1rem;
            font-weight: 500;
        }
    }
}
</style>
